/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { AppConfigService, Environment } from './app/core/config/app-config.service';

const appConfigPath = '/assets/config/app-config.json';

function buildDocumentTitle(config: Environment): string {
  const environmentName = config.environmentName?.toUpperCase();
  const isProduction = ['PROD', 'PRODUCTION', 'PRODUKTION'].includes(environmentName ?? '');

  if (isProduction) {
    return `EnergyConnect - ${config.customerName}`
  }
  else {
    return `EC - ${config.customerName} - ${environmentName} - ${config.version}`;
  }
}

fetch(appConfigPath)
  .then(res => {
    if (!res.ok) {
      throw new Error(`HTTP ${res.status} loading ${appConfigPath}`);
    }
    return res.json() as Promise<Environment>;
  })
  .then(config => {
    AppConfigService.initialise(config);
    document.title = buildDocumentTitle(config);
    return bootstrapApplication(AppComponent, appConfig);
  })
  .catch(err => {
    console.error(
      `AppConfigService: failed to load ${appConfigPath}. ` +
      'In production, ensure docker-entrypoint.sh has run.',
      err
    );
  });
